import type { datadogLogs } from '@datadog/browser-logs';
import type { datadogRum } from '@datadog/browser-rum';

export interface DatadogBrowserSdk {
  rum: typeof datadogRum;
  logs: typeof datadogLogs;
}

// SQR-13012: imported dynamically so the Datadog browser SDKs (~230KB) live in
// a split async chunk, not the entry bundle, and are fetched at idle rather
// than on the boot critical path. Kept in its own module so the tracker's tests
// can mock the load (jest cannot run native `import()` without
// --experimental-vm-modules).
export const loadDatadogBrowserSdk = async (): Promise<DatadogBrowserSdk> => {
  const [{ datadogRum }, { datadogLogs }] = await Promise.all([
    import('@datadog/browser-rum'),
    import('@datadog/browser-logs'),
  ]);
  return { rum: datadogRum, logs: datadogLogs };
};
